/**
 * @module locales/i18n
 * @description vue-i18n 인스턴스 초기화 모듈 — 한국어(ko), 영어(en), 일본어(jp) 메시지를 로드하고
 * 기본 로케일을 'ko', 대체 로케일을 'en'으로 설정하여 i18n 인스턴스를 생성합니다.
 */
import { createI18n } from 'vue-i18n'
import ko from '@/locales/ko.json'
import en from '@/locales/en.json'
import jp from '@/locales/jp.json'

// 메시지 구성
const messages = {
  ko: ko,
  en: en,
  jp: jp
}

// i18n 객체 생성
const i18n = createI18n({
  locale: 'ko', // 기본 언어
  fallbackLocale: 'en', // 대체 언어
  messages // 메시지 추가
})

export default i18n
